import { getRequiredOnboardingSkuIdsByProductLevel } from 'pricing-pages-lib/utils/pricingUtils';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { transformState } from './SelectorUtils';
export const getRequiredOnboardingSkuIdsByProductLevelSelector = createSelectorFromUtil(getRequiredOnboardingSkuIdsByProductLevel, transformState);